import PageHeader from '../../shared/components/layout/PageHeader';
import { getLegalDocumentByKey } from './legalDocuments';
import './LegalDocumentPage.css';

// Renders a single legal/policy document inside the merchant portal account
// area. Content is shared with the public marketing site so Razorpay reviewers
// see identical policies on both surfaces.
const LegalDocumentPage = ({ docKey }) => {
  const doc = getLegalDocumentByKey(docKey);

  if (!doc) {
    return null;
  }

  const { title, eyebrow, lastUpdated, Body } = doc;

  return (
    <section className="section legal-doc-shell">
      <PageHeader title={title} description={`${eyebrow} · Last updated: ${lastUpdated}`} />
      <article className="legal-doc-card">
        <div className="legal-doc-prose">
          <Body />
        </div>
      </article>
    </section>
  );
};

export default LegalDocumentPage;
